import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { lifecycle, compose, nest, withState, withHandlers } from 'recompose'
import T from 'i18n-react'

import styles from './styles.scss'

import Card from './Card'
import CardHeader from 'components/custom/Card/CardHeader'
import Section from 'components/custom/Section/Section'
import Divider from 'components/fulcrum/divider/Divider'
import Actions from './Actions'
import ScheduleSpec from './ScheduleSpec'
import LastUpdated from 'components/display/LastUpdated'

import {
  default as Collapse,
  withCollapse
} from 'components/fulcrum/collapse/Collapse'

import {
  fetchProjectSchedule,
  postProjectSchedule,
  resetProjectScheduleChange
} from './actions'

import { projectIdSelector, segmentSelector } from 'containers/Project/View/selectors'
import { 
  projectScheduleSelector,
  projectScheduleChangeSelector,  
  projectScheduleLastUpdatedNameSelector, 
  projectScheduleLastUpdatedDateSelector,
  projectScheduleChangeValidSelector,
  projectScheduleParamsSelector,
  projectScheduleCSVDataSelector
} from './selectors'

const mapStateToProps = state => {
  return {
    projectId: projectIdSelector(state),
    projectSegment: segmentSelector(state),
    projectSchedule: projectScheduleSelector(state),
    projectScheduleChange: projectScheduleChangeSelector(state),
    projectScheduleLastUpdatedName: projectScheduleLastUpdatedNameSelector(state),
    projectScheduleLastUpdatedDate: projectScheduleLastUpdatedDateSelector(state),
    projectScheduleChangeValid: projectScheduleChangeValidSelector(state),
    projectScheduleParams: projectScheduleParamsSelector(state),
    projectScheduleCSVData: projectScheduleCSVDataSelector(state)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    resetProjectScheduleChange: () => dispatch(resetProjectScheduleChange()),
    fetchProjectSchedule: (projectId) => dispatch(fetchProjectSchedule(projectId)),
    postProjectSchedule: (projectId, params) => dispatch(postProjectSchedule(projectId, params)),
  }
}

class ScheduleCard extends Component {

  onEdit() {
    if(Object.keys(this.props.projectScheduleChange) < 1){
      this.props.resetProjectScheduleChange()
    }
  }

  render() {
    const {
      projectSchedule,
      projectScheduleLastUpdatedDate,
      projectScheduleLastUpdatedName,
      projectScheduleChangeValid,
      projectScheduleParams,
      projectScheduleCSVData,
      collapse,
      toggleCollapse,
      edit,
      toggleEdit,
      postProjectSchedule,
      id,
      projectSegment
    } = this.props

    return (
      <Card>
        <CardHeader title={T.translate('containers.project.scheduleSection.index.header')}>
          <Actions
            collapse={collapse}
            toggleCollapse={toggleCollapse}
            edit={edit}
            disabled={edit && !projectScheduleChangeValid}
            onEdit={()=>{this.onEdit()}}
            toggleEdit={toggleEdit}
            onSave={()=>{postProjectSchedule(id, projectScheduleParams)}}
            id={id}
            csvData={projectScheduleCSVData}
          />
        </CardHeader>
        <LastUpdated name={projectScheduleLastUpdatedName} date={projectScheduleLastUpdatedDate} />
        <Divider className={styles.divider}/>
        <Collapse collapse={collapse}>
          <ScheduleSpec segment={projectSegment} edit={edit} data={projectSchedule}/>
        </Collapse>
      </Card>
    )
  }
}

const ScheduleSection = nest(Section, ScheduleCard)

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withModify = compose(
  withState('edit', 'changeEdit', false),
  withHandlers({
    toggleEdit: ({changeEdit}) => () => changeEdit(e => !e)
  })
)

const enhance = compose(
  withModify,
  withConnect,
  withCollapse,
  lifecycle({
    componentWillMount() { 
      const { fetchProjectSchedule, id } = this.props
      fetchProjectSchedule(id)
    },
    componentWillUnmount() { 
      const { resetProjectScheduleChange } = this.props
      resetProjectScheduleChange()
    }
  })
)

export default enhance(ScheduleSection)
